<template>
  <div class="app-conf-tag-create-page">
    <div class="global-header-wrap">
      <h3>{{ isEdit ? "编辑标签" : "新增标签" }}</h3>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="标签Key" prop="key">
          <el-input
            v-model="ruleForm.key"
            placeholder="请输入标签唯一标识，如：productivity_tools"
            :disabled="isEdit"
          ></el-input>
        </el-form-item>

        <el-form-item label="中文名称" prop="nameZhCN">
          <el-input
            v-model="ruleForm.nameZhCN"
            placeholder="请输入中文名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="英文名称" prop="nameEnUS">
          <el-input
            v-model="ruleForm.nameEnUS"
            placeholder="请输入英文名称（可选）"
          ></el-input>
        </el-form-item>

        <el-form-item label="繁体中文名称">
          <el-input
            v-model="ruleForm.nameZhTW"
            placeholder="请输入繁体中文名称（可选）"
          ></el-input>
        </el-form-item>

        <el-form-item label="中文描述">
          <el-input
            type="textarea"
            :rows="3"
            v-model="ruleForm.descriptionZhCN"
            placeholder="请输入中文描述（可选）"
          ></el-input>
        </el-form-item>

        <el-form-item label="英文描述">
          <el-input
            type="textarea"
            :rows="3"
            v-model="ruleForm.descriptionEnUS"
            placeholder="请输入英文描述（可选）"
          ></el-input>
        </el-form-item>

        <el-form-item label="繁体中文描述">
          <el-input
            type="textarea"
            :rows="3"
            v-model="ruleForm.descriptionZhTW"
            placeholder="请输入繁体中文描述（可选）"
          ></el-input>
        </el-form-item>

        <el-form-item label="图标URL">
          <el-input
            v-model="ruleForm.icon"
            placeholder="请输入图标URL（可选）"
          ></el-input>
        </el-form-item>

        <el-form-item label="标签颜色">
          <el-color-picker v-model="ruleForm.color"></el-color-picker>
          <span style="margin-left: 10px">{{ ruleForm.color }}</span>
        </el-form-item>

        <el-form-item label="排序">
          <el-input-number
            v-model="ruleForm.sort"
            :min="0"
            :max="9999"
            placeholder="请输入排序值，数字越小越靠前"
          ></el-input-number>
          <span style="margin-left: 10px; color: #999"
            >数字越小越靠前</span
          >
        </el-form-item>

        <el-form-item label="状态">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >{{ isEdit ? "保存" : "创建" }}</el-button
          >
          <el-button @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "createAppConfTag",
  data() {
    return {
      isEdit: false,
      tagId: null,
      ruleForm: {
        key: "",
        nameZhCN: "",
        nameEnUS: "",
        nameZhTW: "",
        descriptionZhCN: "",
        descriptionEnUS: "",
        descriptionZhTW: "",
        icon: "",
        color: "#1890ff",
        sort: 0,
        status: 0,
      },
      rules: {
        key: [
          { required: true, message: "请输入标签Key", trigger: "blur" },
          {
            pattern: /^[a-z0-9_]+$/,
            message: "标签Key只能包含小写字母、数字和下划线",
            trigger: "blur",
          },
        ],
        nameZhCN: [
          { required: true, message: "请输入中文名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async getDetail() {
      try {
        const res = await this.$http.getAppConfTagDetail(this.tagId);
        const data = res.data;
        this.ruleForm = {
          key: data.key || "",
          nameZhCN: (data.name && data.name["zh-CN"]) || "",
          nameEnUS: (data.name && data.name["en-US"]) || "",
          nameZhTW: (data.name && data.name["zh-TW"]) || "",
          descriptionZhCN:
            (data.description && data.description["zh-CN"]) || "",
          descriptionEnUS:
            (data.description && data.description["en-US"]) || "",
          descriptionZhTW:
            (data.description && data.description["zh-TW"]) || "",
          icon: data.icon || "",
          color: data.color || "#1890ff",
          sort: data.sort || 0,
          status: data.status !== undefined ? data.status : 0,
        };
      } catch (error) {
        this.elMsg("获取标签详情失败", "error");
      }
    },

    buildRequestData() {
      const data = {
        key: this.ruleForm.key,
        name: {},
        description: {},
        icon: this.ruleForm.icon,
        color: this.ruleForm.color,
        sort: this.ruleForm.sort,
        status: this.ruleForm.status,
      };

      // 构建多语言名称
      if (this.ruleForm.nameZhCN) {
        data.name["zh-CN"] = this.ruleForm.nameZhCN;
      }
      if (this.ruleForm.nameEnUS) {
        data.name["en-US"] = this.ruleForm.nameEnUS;
      }
      if (this.ruleForm.nameZhTW) {
        data.name["zh-TW"] = this.ruleForm.nameZhTW;
      }

      // 构建多语言描述
      if (this.ruleForm.descriptionZhCN) {
        data.description["zh-CN"] = this.ruleForm.descriptionZhCN;
      }
      if (this.ruleForm.descriptionEnUS) {
        data.description["en-US"] = this.ruleForm.descriptionEnUS;
      }
      if (this.ruleForm.descriptionZhTW) {
        data.description["zh-TW"] = this.ruleForm.descriptionZhTW;
      }

      return data;
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const data = this.buildRequestData();
            if (this.isEdit) {
              await this.$http.updateAppConfTag(this.tagId, data);
              this.elMsg("更新成功", "success");
            } else {
              await this.$http.createAppConfTag(data);
              this.elMsg("创建成功", "success");
            }
            this.$router.back();
          } catch (error) {
            this.elMsg(
              this.isEdit ? "更新失败" : "创建失败",
              "error"
            );
          }
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.isEdit = true;
      this.tagId = this.$route.query.id;
      this.getDetail();
    }
  },
};
</script>

<style lang="scss" scoped>
.app-conf-tag-create-page {
  height: 100%;
  overflow-y: auto;
  .global-header-wrap {
    padding: 10px 44px;
  }
  .demo-ruleForm {
    max-width: 800px;
  }
}
</style>
